import type { ReactNode } from 'react';

export const symbol_lock_reset: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M848.5-324Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5q-73-31.5-127.5-86t-85.5-128Q80-399 80-482q0-16 9.5-23.5T110-513q11 0 20.5 7.5T140-483q-2 143 97.5 243.5T480-139q142 0 241-99t99-241q0-142-99-241t-241-99q-100 0-180.5 51.5T177-633h99q13 0 21.5 8.5T306-603q0 13-8.5 21.5T276-573H110q-13 0-21.5-8.5T80-603v-167q0-13 8.5-21.5T110-800q13 0 21.5 8.5T140-770v79q54-86 142.5-137.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156ZM400-325q-14 0-24.5-10.5T365-360v-120q0-14 11.5-24.5T405-515v-45q0-31 22-53t53-22q31 0 53 22t22 53v45q17 0 28.5 10.5T595-480v120q0 14-10.5 24.5T560-325H400Zm35-190h90v-45q0-19-13-32t-32-13q-19 0-32 13t-13 32v45Z"
		/>
	</svg>
);
